import React, { PureComponent } from 'react'
import Satellite from 'public/assets/svg/map_type_satellite.svg'
import RoadMap from 'public/assets/svg/map_type_roadmap.svg'

class MapType extends PureComponent {
    render() {
        const { onClick, mapType } = this.props

        const container = {
            height: '40px',
            width: '40px',
            backgroundColor: '#FFFFFF',
            boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            cursor: 'pointer',

            position: 'absolute',
            top: '10px',
            left: '20px',
            zIndex: '1000',
        }

        let icon = mapType === 'roadmap' ? Satellite : RoadMap

        return (
            <div onClick={e => onClick(mapType === 'roadmap' ? 'satellite' : 'roadmap')} style={container}>
                <img src={icon} style={{ outline: 'none' }} />
            </div>
        )
    }
}

export default MapType
